import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const GatewayKeyPairInfoComponent = ({ handleInnerFormChange, selectedGateway }: any) => (
    <>
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                      <InputContainer
                        isDisabled
                        label="BrId"
                        name="BrId"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'BrId',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.BrId}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Unique Key"
                        name="UniqueId"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'UniqueId',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.UniqueId}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Private Key"
                        name="SigningPrivateKey"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SigningPrivateKey',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.SigningPrivateKey}
                    />
                    <InputContainer
                        isDisabled
                        label="Signing Public Key"
                        name="SigningPublicKey"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SigningPublicKey',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.SigningPublicKey}
                    />
                    <InputContainer
                        isDisabled
                        label="ValidFrom"
                        name="ValidFrom"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'ValidFrom'
                            )
                        }}
                        type="date"
                        value={selectedGateway?.ValidFrom}
                    />
                    <InputContainer
                        isDisabled
                        label=" Valid Until"
                        name="ValidUntil"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'ValidUntil'
                            )
                        }}
                        type="date"
                        value={selectedGateway?.ValidUntil}
                    />
                </div>
            }
            expandedPanel="Signed KeyPair Info"
            headerTitle="Signed KeyPair Info"
        />
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        isDisabled
                        label="Encryption Private Key"
                        name="EncrPrivateKey"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'EncrPrivateKey',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.EncrPrivateKey}
                    />
                    <InputContainer
                        isDisabled
                        label="Encryption Public Key"
                        name="EncrPublicKey"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'EncrPublicKey',
                            )
                        }}
                        type="text"
                        value={selectedGateway?.EncrPublicKey}
                    />
                </div>
            }
            expandedPanel="Encrypted KeyPair Info"
            headerTitle="Encrypted KeyPair Info"
        />
    </>
)

export default GatewayKeyPairInfoComponent;